import {  show } from "../Store/Slices/ToastSlice"
import { store } from "../Store/store"

export const toast = {
    success: (msg) => store.dispatch(show({ severity: 'success', detail: msg, life: 3000,show:true })),
    error: (msg) => store.dispatch(show({ severity: 'error', detail: msg, life: 3000,show:true })),
}
